module.exports = __webpack_public_path__ + "static/media/roundShield.5305062e.jpg";